/** Kto wypełnia formularz — uczestnik nr 0 **jest** rezerwującym przy `PARTICIPANT`. */
export enum FillerType {
  CLIENT = 'client',
  PARTICIPANT = 'participant',
}
